<div class="module">
  <div class="tabs" [ngClass]="{
    w3: isAvailableInsurancePayments,
    w2: !isAvailableInsurancePayments
  }">
    <a (click)="selectSection(1)" [ngClass]="{ active: showSection == 1 }"
      >Amortizaciones</a
    >
    <a (click)="selectSection(2)" [ngClass]="{ active: showSection == 2 }"
      >Períodos de gracia y pagos especiales</a
    >
    <a *ngIf="isInsuranceCalculated && isAvailableInsurancePayments" (click)="selectSection(3)" [ngClass]="{ active: showSection == 3 }"
    >Amortizaciones de seguro</a
  >
  </div>
  <div>
    <app-payments-standard-quote-mobile
      *ngIf="showSection == 1 && !isPureLeasing"
      [payments]="payments"
      [specialPayments]="specialPayments"
      [grace]="grace"
      [idQuote]="id"
      [idDeal]="idDeal"
      [isEdit]="true"
      [tipoProductoFinanciero]="financialProduct"
    ></app-payments-standard-quote-mobile>
    <app-insurance-amortizations-mobile
      *ngIf="showSection == 3 && !isPureLeasing"
      [payments]="insurancePayments"
      [quantity]="1"
      [currency]="currency"
      [readOnly]="true"
      [tipoProductoFinanciero]="financialProduct"
      [grace]="grace"
    ></app-insurance-amortizations-mobile>
  </div>
</div>
